import { render, staticRenderFns } from "./TransactionTypeSelect.vue?vue&type=template&id=452056d0&"
import script from "./TransactionTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./TransactionTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('452056d0')) {
      api.createRecord('452056d0', component.options)
    } else {
      api.reload('452056d0', component.options)
    }
    module.hot.accept("./TransactionTypeSelect.vue?vue&type=template&id=452056d0&", function () {
      api.rerender('452056d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/sales-transactions/TransactionTypeSelect.vue"
export default component.exports